import type AuthConnector from "../data/authConnector";
import Policy from "../entities/policy";
import type EventBus from "../services/eventBus";
import RepositoryBase from "./repositoryBase";

export default class PolicyRepository extends RepositoryBase<AuthConnector> {
  constructor(protected apiFactory: ReturnType<typeof AuthConnector.Factory>, protected eventBus: EventBus) {
    super(apiFactory, eventBus);
  }

  passwordPolicy() {
    return this.callApi(api => api.all("password_policy").getEntity(Policy));
  }

  updatePasswordPolicy(policy: Policy) {
    return this.callApi(api => api.all("password_policy").putEntity(policy, Policy));
  }
}
